import { render, staticRenderFns } from "./IconsInterfaceProjects.vue?vue&type=template&id=0828a3bc&scoped=true&"
import script from "./IconsInterfaceProjects.vue?vue&type=script&lang=js&"
export * from "./IconsInterfaceProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0828a3bc",
  null
  
)

export default component.exports